<template>

<svg 
	 xmlns="http://www.w3.org/2000/svg"   
	 viewBox="-11.5 780.5 24 24" >
<path d="M8.21,783.44l-16.37,16.37l-1.34-1.34l15.04-15.03H8.21z M9.55,787.47L-5.48,802.5l-1.33-1.34l16.37-16.37V787.47z
	 M10.5,782.5v7.57H8.61v-5.67H2.93v-1.89H10.5z"/>
</svg>

</template>